module.exports = __webpack_public_path__ + "img/ycyl.6d81e84a.png";